import {http} from '@/src/services/config/config-receituario'

export default{
    reportCfta:(token, dataIni, dataFim)=>{
        return http.get(`webservices/cfta?startDate=${dataIni}&endDate=${dataFim}`, {
            headers:{
                'Authorization':token
            }
        })
       
    },
}